import { render } from "./IconRoomHousekeeping.svg?vue&type=template&id=fd8d2eea?inline"
const script = {}

import exportComponent from "C:\\build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__